import React from "react";
import { Navigate } from "react-router";

import analytics from "fond/analytics";
import * as Auth from "fond/cognito/auth";
import { LOGOUT_EVENT } from "fond/constants";

import { stopImpersonating } from "../impersonate";

/**
 * When rendered, signs the user out and redirects the user
 * to the /signin route.
 */
const SignOut: React.FC = () => {
  stopImpersonating();
  Auth.signOut();
  analytics.track("Signed out");
  analytics.reset();
  sessionStorage.clear();

  // Trigger cross-tab logout by setting a timestamp in localStorage
  // This will cause other tabs to detect the logout via storage event
  localStorage.setItem(LOGOUT_EVENT, Date.now().toString());

  return <Navigate to="/signin" />;
};

export default SignOut;
